'use es6';

import AsyncComponentLoading from 'email-management-lib/refactor/components/app/asyncLoaders/AsyncComponentLoading';
import Loadable from 'UIComponents/decorators/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncPortalSuspensionAlertContainer = Loadable({
  loader: () => import( /* webpackChunkName: "portal-health-status" */'email-management-lib/refactor/containers/PortalSuspensionAlertContainer'),
  LoadingComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "portal-health-status"
  }, props)),
  ErrorComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "portal-health-status"
  }, props, {
    navMarkerErrorName: "PORTAL_SUSPENSION_LOAD_FAILED"
  }))
});
export default AsyncPortalSuspensionAlertContainer;